document.addEventListener('DOMContentLoaded', () => {
  // Grabbing VO's medium blog posts
  var $content = document.querySelector("#blog-posts-content")
  if($content) {
    $content.classList.add("hide")
    var $loader = document.querySelector("h2.loading-placeholder")
    var request = new XMLHttpRequest()
    request.open('GET', 'https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/vacationoffer', true)
    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        var data = JSON.parse(this.response)
        var output = ""
        data.items.map(item => {
          output += '<div class="blog-post"><header>'
          output += '<h2><a href="' + item.link + '">' + item.title + "</a></h2>"
          output +=
            '<div class="post-meta"><span>By ' + item.author + "</span></div>"
          output += "</header>"
          output += '<div class="blog-content">' + item.content + "</div>"
          output += "</div>"
        })
        $content.innerHTML = output
        $loader.classList.add("animated", "fadeOut")
        $loader.style.display = "none"
        $content.classList.remove("hide")
        $content.classList.add("animated", "fadeIn")
      } else {
        console.log("error") //eslint-disable-line
      }
    }
    request.onerror = function() {
      // There was a connection error of some sort
      console.log("error") //eslint-disable-line
    }
    request.send()
  }
})
